$(function () {
  function myAreaVip() {
    const consumeKgInput = $('.js-mav__consume-kg-input')
    const consumeGrInput = $('.js-mav__consume-gr-input')
    const consumeKgAlert = $('.js-mav__consume-kg-alert')
    const consumeGrAlert = $('.js-mav__consume-gr-alert')
    const legalsInput = $('.js-mav__legals-input')
    const legalsAlert = $('.js-mav__legals-alert')
    const consumeSubmit = $('.js-mav__consume-submit')
    const disableAlertSubmit = $('.js-mav__disable-alert-submit')
    const copyContainer = $('.js-mav__copy')

    consumeSubmit.on('click', async function () {
      consumeKgAlert.text('').hide()
      consumeGrAlert.text('').hide()
      legalsAlert.text('').hide()
      consumeSubmit.removeClass('btn--success')
      consumeSubmit.removeClass('btn--error')
      disableAlertSubmit.removeClass('btn--success')
      disableAlertSubmit.removeClass('btn--error')

      const consumeKgValue = parseInt(consumeKgInput.val())
      const consumeGrValue = parseInt(consumeGrInput.val())
      const legalsValue = legalsInput.prop('checked')

      let haveErrors = false

      if (consumeKgValue == 0 && consumeGrValue == 0) {
        consumeKgAlert.text('Debes introducir un número válido').show()
        consumeGrAlert.text('Debes introducir un número válido').show()
        haveErrors = true
      }

      if (consumeGrValue > 999 || consumeGrValue < 0) {
        consumeGrAlert.text('Debes introducir un número entre 0 y 999').show()
        haveErrors = true
      }

      if (consumeKgValue < 0 || consumeKgValue > 10) {
        consumeKgAlert.text('Debes introducir un número entre 0 y 10').show()
        haveErrors = true
      }

      if (legalsValue == false) {
        legalsAlert.text('Debes aceptar las condiciones').show()
        haveErrors = true
      }

      if (haveErrors) {
        return
      }

      consumeSubmit.addClass('btn--loading')

      try {
        await postConsumeAlarm(consumeKgValue, consumeGrValue)
        consumeSubmit.removeClass('btn--loading')
        consumeSubmit.addClass('btn--success')
        copyContainer.text('Ya eres VIP y tienes un 7% de descuento aplicado en todos tus menús')
      } catch (error) {
        console.error('Error: ', error)
        consumeSubmit.removeClass('btn--loading')
        consumeSubmit.addClass('btn--error')
      }
    })

    disableAlertSubmit.on('click', async function () {
      disableAlertSubmit.addClass('btn--loading')

      try {
        await disableAlarm()
        disableAlertSubmit.removeClass('btn--loading')
        disableAlertSubmit.addClass('btn--success')
        location.reload()
      } catch (error) {
        console.error('Error: ', error)
        disableAlertSubmit.removeClass('btn--loading')
        disableAlertSubmit.addClass('btn--error')
      }
    })
  }
  myAreaVip()
})

async function postConsumeAlarm(kilos, grams) {
  const data = {
    kilos,
    grams,
  }

  const response = await $.ajax({
    url: `${window.Shopify.routes.root}apps/natuka-app/alarms`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(data),
    dataType: 'json',
  })

  return response
}

async function disableAlarm() {
  const response = await $.ajax({
    url: `${window.Shopify.routes.root}apps/natuka-app/alarms`,
    method: 'DELETE',
    contentType: 'application/json',
    dataType: 'json',
  })

  return response
}
